import { COMPANY } from '../../data/content';

export default function WhatsAppButton() {
  const href = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
    'Hello Banmore Electricals, I would like to enquire about your CRGO transformer core products.'
  )}`;
  return (
    <a
      data-testid="whatsapp-float-btn"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 transition-transform duration-300 hover:scale-110"
    >
      <svg viewBox="0 0 32 32" className="h-7 w-7 fill-current" aria-hidden="true">
        <path d="M16.004 3C9.383 3 4 8.383 4 15.004c0 2.117.555 4.184 1.61 6.008L4 29l8.164-1.57a11.94 11.94 0 0 0 3.84.64C22.62 28.07 28 22.688 28 16.067 28 9.446 22.62 4.063 16.004 3zm0 21.86c-1.2 0-2.383-.215-3.5-.64l-.25-.098-4.844.93.922-4.72-.164-.242a9.86 9.86 0 0 1-1.52-5.286c0-5.46 4.446-9.902 9.914-9.902 2.648 0 5.137 1.032 7.008 2.903a9.83 9.83 0 0 1 2.902 7.004c0 5.46-4.445 9.9-9.914 9.9zm5.44-7.41c-.297-.15-1.762-.867-2.035-.966-.273-.101-.472-.15-.672.15-.199.297-.77.965-.945 1.164-.172.199-.348.223-.645.075-.297-.15-1.258-.463-2.395-1.477-.885-.789-1.483-1.764-1.657-2.06-.172-.298-.019-.458.13-.606.134-.133.297-.348.446-.522.15-.174.199-.298.298-.497.099-.199.05-.372-.025-.522-.075-.15-.672-1.62-.92-2.22-.242-.582-.487-.503-.672-.512l-.573-.01c-.199 0-.522.074-.795.372-.273.298-1.043 1.02-1.043 2.487s1.068 2.884 1.217 3.083c.149.199 2.104 3.212 5.098 4.504.712.307 1.268.49 1.701.628.715.227 1.366.195 1.88.118.574-.086 1.762-.72 2.01-1.414.248-.695.248-1.29.173-1.414-.074-.124-.272-.198-.57-.347z" />
      </svg>
    </a>
  );
}
